import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { ELoginAs, LIVE_LOGINS } from '@aqx-core/common/api/auth';

export function useLoginInputLabels(selectedTab: ELoginAs | undefined) {
  const { t } = useTranslation();

  return useMemo(() => {
    const isLiveTab = selectedTab === ELoginAs.LIVE;
    const isLiveTabs = selectedTab && LIVE_LOGINS.includes(selectedTab);

    let userIdInputLabel: string;
    if (isLiveTab) {
      userIdInputLabel = `${t('Email')} / ${t('Username')}`;
    } else if (isLiveTabs) {
      userIdInputLabel = t('Account ID', { context: 'live' });
    } else {
      userIdInputLabel = t('Account ID', { context: 'demo' });
    }

    let userIdInputPlaceholder: string;
    if (isLiveTab) {
      userIdInputPlaceholder = `${t('Enter your email')} / ${t('Username').toLowerCase()}`;
    } else {
      userIdInputPlaceholder = t('Enter your account ID');
    }

    return {
      userIdInputLabel,
      userIdInputPlaceholder
    };
  }, [selectedTab, t]);
}
